module.exports = __webpack_public_path__ + "img/628-0137a7.png";